var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineShoppingCartCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5507 21.0004C24.3007 21.0004 24.9607 20.5904 25.3007 19.9704L28.8807 13.4804C29.2507 12.8204 28.7707 12.0004 28.0107 12.0004H13.2107L12.2707 10.0004H9.00073V12.0004H11.0007L14.6007 19.5904L13.2507 22.0304C12.5207 23.3704 13.4807 25.0004 15.0007 25.0004H27.0007V23.0004H15.0007L16.1007 21.0004H23.5507ZM14.1607 14.0004H26.3107L23.5507 19.0004H16.5307L14.1607 14.0004ZM15.0007 26.0004C13.9007 26.0004 13.0107 26.9004 13.0107 28.0004C13.0107 29.1004 13.9007 30.0004 15.0007 30.0004C16.1007 30.0004 17.0007 29.1004 17.0007 28.0004C17.0007 26.9004 16.1007 26.0004 15.0007 26.0004ZM25.0007 26.0004C23.9007 26.0004 23.0107 26.9004 23.0107 28.0004C23.0107 29.1004 23.9007 30.0004 25.0007 30.0004C26.1007 30.0004 27.0007 29.1004 27.0007 28.0004C27.0007 26.9004 26.1007 26.0004 25.0007 26.0004Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineShoppingCartCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-shopping_cart_circle-40px.e3c9044b5b58e166c6320840da4486e4.svg";
export { ForwardRef as ReactComponent };